import React from 'react';
import { Link } from 'react-router-dom';
import AccountMultiplePlus from '../../common/icons/AccountMultiplePlus';
import ShieldKey from '../../common/icons/ShieldKey';

export default function RegisterParents() {
  return (
    <div className='my-5 pt-2'>
      <span className='flex justify-between align-center has-text-link is-italic hand-pointer pr-2'>
        <Link to='/forget-password'>
          <div
            className='is-size-7 is-link is-small flex justify-start align-center hand-pointer px-2 py-1'
            style={{ width: 'max-content', borderRadius: 25 }}
          >
            <ShieldKey size={16} color={'#495fc7'} />
            <span className='ml-1'>Forget Password</span>
          </div>
        </Link>
        <Link to='/register'>
          <div
            className='is-size-7 is-link flex justify-end align-center hand-pointer px-2 py-1'
            style={{ width: 'max-content', borderRadius: 25 }}
          >
            <AccountMultiplePlus size={16} color={'#495fc7'} />
            <span className='ml-1'>Register Ortu/Wali</span>
          </div>
        </Link>
      </span>
    </div>
  );
}
